import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Scheduling|Schedule an Exam|Vue';

export type SSOEgressVue =
	| 'CPSSOEgressVueButton'
	| 'CPSSOEgressVueLoadingMessage'
	| 'CPSSOEgressVueRedirectFailure'
	| 'CPSSOEgressVueTabTitle'
	| 'CPSSOEgressVuePageTitle'
	| 'CPSSOEgressVuePageDescription';

export const ssoEgressVueLocs: LocDefs<SSOEgressVue> = {
	CPSSOEgressVueButton: {
		defaultValue: 'SSO to Vue',
		description: 'Button to SSO to Vue.',
		displayPath: `${dpRoot}|SSO Button`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
		htmlAllowed: false,
		legacyName: 'CandidateAccess.Integration.Egress.PearsonVue/Scheduling.Exam.Button.SsoToVue',
	},
	CPSSOEgressVueLoadingMessage: {
		defaultValue: 'Connecting to provider',
		description: 'Message displayed while SSO is in flight.',
		displayPath: `${dpRoot}|SSO Loading Message`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressVueRedirectFailure: {
		defaultValue:
			'You should be automatically redirected in a moment, but if you are not, please click the button below.',
		description: 'Message displayed if auto redirect fails.',
		displayPath: `${dpRoot}|SSO Redirect Failure`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
		htmlAllowed: true,
	},
	CPSSOEgressVueTabTitle: {
		defaultValue: 'Schedule an Exam',
		description: 'Tab title of Vue SSO page.',
		displayPath: `${dpRoot}|Tab Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
		htmlAllowed: false,
		legacyName: 'CandidateAccess.Integration.Egress.Vue/Scheduling.Exam.Title.TabTitle',
	},
	CPSSOEgressVuePageTitle: {
		defaultValue: 'Vue SSO',
		description: 'Title of Vue SSO page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
		htmlAllowed: false,
		legacyName: 'CandidateAccess.Integration.Egress.Vue/Scheduling.Exam.Title.PageTitle',
	},
	CPSSOEgressVuePageDescription: {
		defaultValue: '',
		description: 'Title of Vue SSO page.',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressPearsonVue,
		portal: 'CP',
		htmlAllowed: true,
		legacyName:
			'CandidateAccess.Integration.Egress.Vue/Scheduling.Exam.Content.PageDescription',
	},
};

export const LOC_KEYS = MapLocKeys<SSOEgressVue>(ssoEgressVueLocs);
export const cpVueSSOLocNames = LOC_KEYS;
